export class Permiso {
  link = '';
  path = '';
}
